type Subscriber = () => void

class BusinessDevelopmentStore {
    private _accountAdvertiserId?: number
    private _isAllAdvertisers: boolean = false

    get accountAdvertiserId() {
        return this._isAllAdvertisers ? undefined : this._accountAdvertiserId
    }

    get selectedAdvertiserId() {
        return this._accountAdvertiserId
    }

    get isAllAdvertisers() {
        return this._isAllAdvertisers
    }

    get scopeKey(): string | undefined {
        if (this._accountAdvertiserId === undefined) {
            return undefined
        }

        return this._isAllAdvertisers ? 'allAdvertisers' : `${this._accountAdvertiserId}`
    }

    setAccountAdvertiserId = (accountAdvertiserId: number) => {
        this._accountAdvertiserId = accountAdvertiserId
        this.notifySubscribers()
    }

    setIsAllAdvertisers = (isAllAdvertisers: boolean) => {
        this._isAllAdvertisers = isAllAdvertisers
        this.notifySubscribers()
    }

    reset = () => {
        this._accountAdvertiserId = undefined
        this._isAllAdvertisers = false
        this.notifySubscribers()
    }

    private subscribers: Subscriber[] = []

    subscribe = (subscriber: Subscriber) => {
        this.subscribers.push(subscriber)

        return () => this.unsubscribe(subscriber)
    }

    unsubscribe = (subscriber: Subscriber) => {
        this.subscribers = this.subscribers.filter((sb) => sb !== subscriber)
    }

    private notifySubscribers = () => {
        this.subscribers.forEach((subscriber) => subscriber())
    }
}

export const businessDevelopmentStore = new BusinessDevelopmentStore()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/BusinessDevelopmentStore.ts